import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-controls", "disabled"]
const _hoisted_2 = { class: "truncate" }
const _hoisted_3 = { class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.active = false), ["esc"]))
  }, [
    _createElementVNode("button", {
      class: "flex min-h-11 w-full items-center justify-between gap-3 rounded-2xl border border-white/70 bg-slate-100/75 px-4 py-3 text-left text-sm font-medium text-slate-700 shadow-sm hover:bg-white/90 focus:outline-none focus:ring-2 focus:ring-sky-200 disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100/80 disabled:text-slate-400",
      "aria-haspopup": "true",
      "aria-controls": _ctx.dropdown_menu_id,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.active = !_ctx.active), ["stop"])),
      disabled: _ctx.disabled,
      type: "button"
    }, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "selected")
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_ion_icon, { name: "chevron-down-outline" })
      ])
    ], 8, _hoisted_1),
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["absolute z-30 w-full overflow-hidden rounded-2xl border border-white/75 bg-white/92 p-2 shadow-[0_20px_40px_rgba(148,163,184,0.28)] ring-1 ring-slate-200/70 backdrop-blur", _ctx.direction === 'up' ? 'bottom-[calc(100%+0.75rem)]' : 'top-[calc(100%+0.75rem)]']),
          id: _ctx.dropdown_menu_id,
          role: "menu"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("a", {
              key: option,
              href: "#",
              class: "block rounded-xl px-3 py-2 text-sm text-slate-700 hover:bg-slate-100/90 hover:text-slate-900",
              onClick: _withModifiers(($event: any) => {_ctx.$emit('clicked', option); _ctx.active = false}, ["prevent"])
            }, [
              _renderSlot(_ctx.$slots, "option", { option: option })
            ], 8, _hoisted_5))
          }), 128))
        ], 10, _hoisted_4))
      : _createCommentVNode("", true)
  ], 32))
}